export default {
    
mounted :function() {
    history.pushState(null, null, document.URL);
}
    

}